import { createContext, useContext } from 'react';

import { CONTEXT_VALUE } from '@interlayer/js/app/components/main/Registration/constants';

export const RegistrationContext = createContext(CONTEXT_VALUE);

export const useRegistrationContext = () => useContext(RegistrationContext);
